import { DropResult } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import { ProjectStateType } from "../EditProjectContext";
import { CardType } from "../LeftSide/CardType";
import { getRouteById } from "./getRouteById";
import { handleSpdr } from "./handleSpdr";
import { handlePdsr } from "./handlePdsr";

export const handleCardOnDragEnd = async (result: DropResult, projectState: ProjectStateType) => {
  const { project } = projectState;
  const { draggableId, destination } = result;
  const cardType = result.source?.droppableId;

  if (!destination) {
    return;
  }

  const routeId = parseInt(destination.droppableId, 10);

  if (Number.isNaN(routeId)) {
    toast(`Error while try to add ${cardType}`, {
      type: "error",
    });
    return;
  }

  const route = getRouteById(routeId, project);

  if (!route) {
    toast(`Error while try to add ${cardType}`, {
      type: "error",
    });
    return;
  }

  const parsedDraggableId = parseInt(draggableId, 10);

  if (Number.isNaN(parsedDraggableId)) {
    toast(`Error while try to add SPDR`, {
      type: "error",
    });
    return;
  }

  if (cardType === CardType.spdr) {
    await handleSpdr(draggableId, route, routeId, projectState, parsedDraggableId);
    return;
  }
  if (cardType === CardType.pdsr) {
    await handlePdsr(draggableId, route, routeId, projectState, parsedDraggableId);
  }
};
